import React from "react";
import { SparksBlackBanner } from "../shared/SparksBlackBanner";
import { SparksFeatureSupportContent } from "./SparksFeatureSupportContent";

export const SparksFeatureSupportPage = () => {
  return (
    <main className="w-full flex flex-col brand-sparks">
      <div className="w-full bg-sky-300 pt-3xl pb-4xl">
        <SparksFeatureSupportContent />
      </div>
    </main>
  );
};
